import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { noop } from 'lodash'
import { Divider, Stack, Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'

// generic components
import FormModalHeading from 'components/generic/modals/form-modal/FormModalHeading'
import FormModalCustomActionBar from 'components/generic/modals/form-modal/FormModalCustomActionBar'
import DataGrid from 'components/generic/datagrid'
import Loading from 'components/generic/Loading'
import AlertModal from 'components/generic/modals/dialog-modal/AlertModal'
import { useGetTransferLazyQuery, useGetTransfersQuery } from 'services/inboundTickets'
import { transformStrToCapital } from 'utils/router'
import { getActionButtons, getColumns, getRows, useStyles } from './helperSelectAvailableTransfer'
import { dispatchSnackbar } from 'utils/helpers'

const SelectAvailableTransfer = ({ onFormStateChange, onHideModal }) => {
  const dispatch = useDispatch()
  const [selected, setSelected] = useState([])
  const { selectedYard } = useSelector(state => state.auth)
  const receivingYard = transformStrToCapital(selectedYard)
  const [showTransferModal, setShowTransferModal] = useState(false)
  const classes = useStyles()
  const navigate = useNavigate()
  const { data: transfersData, isLoading: isLoadingTransfers } = useGetTransfersQuery(
    {},
    { refetchOnMountOrArgChange: true },
  )
  const [getTransfer, { data, error }] = useGetTransferLazyQuery()

  const getSendingYard = () => transfersData?.Items?.find(transfer => transfer.id === selected[0])?.sendingYard

  useEffect(() => {
    onFormStateChange(false)
  }, [])

  useEffect(() => {
    if (data) {
      setShowTransferModal(false)
      onHideModal()
      navigate(`/app/purchases/ticket-library/${data.id}`)
    } else if (error) {
      dispatchSnackbar(dispatch, 'error', error?.data?.error || 'Error fetching transfer data')
    }
  }, [data, error])

  const getTransferData = () => {
    getTransfer({ transferId: selected[0] })
  }

  if (isLoadingTransfers) {
    return <Loading localized />
  }

  return (
    <Stack height="100vh">
      {showTransferModal && (
        <AlertModal
          open={showTransferModal}
          modalType="payment"
          title="Inventory Transfer"
          question={`Confirm that you want to transfer the selected inventory from ${transformStrToCapital(getSendingYard())} to ${receivingYard}`}
          confirmLabel="CONFIRM TRANSFER"
          cancelLabel="CANCEL"
          onClose={() => {
            setShowTransferModal(false)
          }}
          onSubmit={getTransferData}
        />
      )}
      <FormModalHeading
        title="Select From Available Transfers"
        backButtonPosition="right"
        onBack={() => onHideModal()}
        hideFooter
      />
      <Divider />
      <Box flexGrow={1}>
        <DataGrid
          columns={getColumns(selected)}
          rows={getRows(transfersData)}
          height="auto"
          className={classes.root}
          selectionModel={selected}
          onSelectionModelChange={newSelectionModel => {
            setSelected(newSelectionModel)
          }}
        />
      </Box>
      <FormModalCustomActionBar
        buttonConfigs={getActionButtons(setShowTransferModal, onHideModal, selected.length > 0)}
        justify="flex-start"
      />
    </Stack>
  )
}

SelectAvailableTransfer.propTypes = {
  onFormStateChange: PropTypes.func,
  onHideModal: PropTypes.func,
}

SelectAvailableTransfer.defaultProps = {
  onFormStateChange: noop,
  onHideModal: noop,
}

export default SelectAvailableTransfer
